import { useToken } from "@chakra-ui/react";
import { ChakraFontSizeToken } from "../interface";
/**
 * Converts font size token (rem/em/px) to pixels
 */
export const convertFontSizeToPx = (
  tokenValue: string | number | string[]
): number => {
  const value = Array.isArray(tokenValue) ? tokenValue[0] : tokenValue;
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    if (value.endsWith("px")) return parseFloat(value);
    if (value.endsWith("rem") || value.endsWith("em"))
      return parseFloat(value) * 16;
  }
  return 12;
};

/**
 * Resolves Chakra font size token and converts to pixels
 */
export const useFontSizeInPx = (fontSize: ChakraFontSizeToken): number => {
  return convertFontSizeToPx(useToken("fontSizes", fontSize));
};
